import { handlePostRequest, handleGetRequest } from "../hooks/api";

export async function handleAddGroup(payload) {
  const response = await handlePostRequest(
    "/group/createGroup/",
    payload,
    undefined,
    true
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
}
export async function handleAddGroupPost(payload, groupId) {
  const response = await handlePostRequest(
    `/posting/create/${groupId}`,
    payload,
    undefined,
    true
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
}

export async function handlegetAllGroup(payload) {
  const response = await handlePostRequest(
    "/group/getAllGroup",
    payload,
    undefined,
    false
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
}
export async function handleGetAllPosts(payload, groupId) {
  const response = await handlePostRequest(
    `/posting/getPost/${groupId}`,
    payload,
    undefined,
    false
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
}

export async function handleJoinGroup(groupId) {
  const response = await handlePostRequest(
    `/group/${groupId}/join`,
    {},
    undefined,
    false
  );

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}

export async function handleLeaveGroup(targetGroupId) {
  const response = await handlePostRequest(
    `/group/${targetGroupId}/leave`,
    {},
    undefined,
    false
  );

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}
export async function handleGetGroupDetails(payload, targetGroupId) {
  const response = await handlePostRequest(
    `/group/getGroup/${targetGroupId}`,
    payload,
    {},
    false
  );

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}
